var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83594 3.33329C3.46775 3.33329 3.16927 3.63177 3.16927 3.99996V13.3333C3.16927 13.7015 3.46775 14 3.83594 14H13.1693C13.5375 14 13.8359 13.7015 13.8359 13.3333V3.99996C13.8359 3.63177 13.5375 3.33329 13.1693 3.33329H3.83594ZM1.83594 3.99996C1.83594 2.89539 2.73137 1.99996 3.83594 1.99996H13.1693C14.2738 1.99996 15.1693 2.89539 15.1693 3.99996V13.3333C15.1693 14.4379 14.2738 15.3333 13.1693 15.3333H3.83594C2.73137 15.3333 1.83594 14.4379 1.83594 13.3333V3.99996Z",
    fill: "#EB7930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83594 6.66663C1.83594 6.29844 2.13441 5.99996 2.5026 5.99996H14.5026C14.8708 5.99996 15.1693 6.29844 15.1693 6.66663C15.1693 7.03482 14.8708 7.33329 14.5026 7.33329H2.5026C2.13441 7.33329 1.83594 7.03482 1.83594 6.66663Z",
    fill: "#EB7930"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1693 0.666626C11.5375 0.666626 11.8359 0.965103 11.8359 1.33329V3.99996C11.8359 4.36815 11.5375 4.66663 11.1693 4.66663C10.8011 4.66663 10.5026 4.36815 10.5026 3.99996V1.33329C10.5026 0.965103 10.8011 0.666626 11.1693 0.666626Z",
    fill: "#EB7930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83594 0.666626C6.20413 0.666626 6.5026 0.965103 6.5026 1.33329V3.99996C6.5026 4.36815 6.20413 4.66663 5.83594 4.66663C5.46775 4.66663 5.16927 4.36815 5.16927 3.99996V1.33329C5.16927 0.965103 5.46775 0.666626 5.83594 0.666626Z",
    fill: "#EB7930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.400259acfc7c50370f2ea9dcc2a5abaf.svg";
export { ForwardRef as ReactComponent };